import React from 'react';

import { HtmlText, formatText } from 'core/i18n';

import EmailIcon from 'assets/icons/icon-email-sent-color.svg';
import EditIcon from 'assets/icons/icon-edit-3.svg';
import './additionalDataAdvise.scss';

export const AdditionalDataAdvise = ({
    address,
    additionalInfo,
    postalCodeAndTown,
    onClickAdExtraData,
    onClickEdit,
}) => {
    const title = `addressInfo-address${additionalInfo ? 'Complete' : 'Incomplete'}Title`;
    return (
        <div className="extra-data-message">
            <div className="extra-data-message__title">{HtmlText(formatText(title))}</div>
            <div className="extra-data-message__content">
                <div className="extra-data-message__content__email-icon">
                    <img src={EmailIcon} alt="email-sent-icon" className="" />
                </div>
                <div className="extra-data-message__content__address">
                    <div>{address}</div>
                    {additionalInfo || (
                        <p onClick={onClickAdExtraData} className="extra-data-message__content__address__add-data">
                            {formatText('addressInfo-addInfoAdditional')}
                        </p>
                    )}
                    <div>{postalCodeAndTown}</div>
                </div>
                <div className="extra-data-message__content__edit" onClick={onClickEdit}>
                    <img src={EditIcon} alt="edit-icon" className="" />
                    <p>{formatText('button-edit')}</p>
                </div>
            </div>
        </div>
    );
};
